import { CatalogMap } from 'features/catalog';

export function getProductCodes(data: CatalogMap): ReadonlyArray<string> {
    const productCodes: Array<string> = [];
    data.forEach((products) => {
        const productCode = Array.from(products).map((product) => product.codeProduit);
        productCodes.push(...productCode);
    });

    return productCodes;
}
